/* eslint-disable no-loop-func */
/* eslint-disable array-callback-return */
import { useState,useEffect,useContext } from "react";
import { useParams } from 'react-router-dom';
import ReportContext,{ Types } from "../../../context/ReportsContext/ReportContext";
//import { useMutation } from "@apollo/client";
import { Grid } from "@material-ui/core";
import Box from '@mui/material/Box';
import {
  EDIT_DATAREPORT_CAMPS
} from "../../../Querys/reports/querys";
import SelectIcon from "../../../assets/icons/reportSelect.svg";
import selSelectIcon from "../../../assets/icons/selReportSelect.svg";
import SeeIcon from "../../../assets/icons/reportSee.svg";
import selSeeIcon from "../../../assets/icons/selReportSee.svg";
import aplicar from "../../../assets/icons/aplicar.svg";
import { SuccessfulAlert } from "../../../alerts/successAlerts";
import SaveIcon from '@mui/icons-material/Save';
import TreeView from "./TreeView";
import FilesTable from "./FilesTable";
import { removeAccents } from '../../../helpers/RemoveAccents';
import { Queue } from '../../../helpers/queue';

type RowValues = Record<string, string | number>; 

const FilterContainer = () => {
  const { state,dispatch} = useContext(ReportContext);
    const { id } = useParams<{ id: string }>();
    const [selSelect    ,setSelSelect  ]  = useState(true);
    const [selView      ,setSelView    ]  = useState(false);
    const [addTxt       ,setAddTxt     ]  = useState(false);     
    const [valueFilter     ,setValueFilter]  = useState(0);
    const [chargeOnlyTime  ,setChargeOnlyTime]  = useState(false);
    const [count, setCount] = useState(0);       
    const [deleteColumns, setDeleteColumns] = useState([]);
    
    const [currentRowValues, setCurrentRowValues] = useState<RowValues>({});
    
    const handleChangeFile = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;        
        // Actualiza el estado local de la fila (inmutablemente)
        setCurrentRowValues(prevValues => ({
            ...prevValues,
            [name]: value,
        }));

       dispatch({
            type: Types.INPUT_VALUES,
            payload: { [name]: value },
          });        
    };       
  
    useEffect(() => {      
       if(state?.reportPreviewData?.inpuntValues.length===0){
         setCurrentRowValues({});
       }
     }, [state?.reportPreviewData?.inpuntValues]);
    
const handleAplicar = () => {  
  const originalReport = [...state?.reportPreviewData?.report];
  const filters = Object.entries(currentRowValues).filter(([_, value]) => value !== "" && value !== null && value !== undefined);
  if (filters.length === 0) {
      dispatch({
      type: Types.UPDATE_REPORT_DATA,
      payload: originalReport,
    });
    return;
  }
  
  const filteredReport = originalReport.filter((row) => {
    return filters.every(([key, value]) => {
      const field = row[key];
      if (field === null || field === undefined) return false;
      const fieldStr = removeAccents(field.toString().toUpperCase());
      const searchStr = removeAccents(value.toString().toUpperCase());
      return fieldStr.includes(searchStr);
    });
  });

  dispatch({
    type: Types.UPDATE_REPORT_DATA,
    payload: filteredReport,
  });
}; 
    // async function run () {
    //   let val:any 
    //    while (!queue.isEmpty()) {
    //     let array:any =[]          
    //     const res = queue.dequeue()

    //     state?.reportPreviewData?.reportFilter.map((re:any)=>{
    //       for (val of Object.values(re)) {
    //        if(removeAccents(val.toString().toUpperCase()).includes(res.toUpperCase())){
    //             array.push(re)             
    //          }      
    //        }          
    //     })
    //     state?.reportPreviewData?.setReportFilter(array)       
    //  }
    // }
    //const [editDateReportCamps] = useMutation(EDIT_DATAREPORT_CAMPS); 

  const handleSelect=()=>{   
    setSelView(false)
    setValueFilter(0)     
    selSelect===false?setSelSelect(true):setSelSelect(false)        
  }

  const handleSee=()=>{   
    setSelSelect(false)   
    setValueFilter(1)       
    selView===false?setSelView(true):setSelView(false)        
  }

 const namecoulumsID = state?.reportPreviewData?.columnas.map(
  (valor: string, index: number) => ({
    value: valor,
    id: `${index + 1}columnName`,
  })
);
  
  return (
    <Box className='containerFilterInforme'>
      <Grid className="buttonsReportSingle">
        {selView=== false ?
         <img  
           className='see' 
           src={SeeIcon} alt="see"
           onClick={handleSee} />
         :<img  
           className='see' 
           src={selSeeIcon} alt="see"
           onClick={handleSee} /> 
        }   
        {selSelect === false?
         <img  className='select' 
            src={SelectIcon} alt="select" 
            onClick={handleSelect}/>
         :<img  className='select' 
           src={selSelectIcon} alt="select" 
           onClick={handleSelect}/>
        }   
      </Grid>
      <Grid className="separatorReportSingle">   
          <div className="imgAplicar">
            {selSelect === true? 
                <img  
                className='aplicar' 
                src={aplicar} alt="aplicar"
                onClick={()=> handleAplicar()}
                />:<></> 
            }
            </div>
           <div className="containerFilter">      
           {
             //selSelect === true || selView=== true?         
             //<SaveIcon  className='save' fontSize="small" color="disabled"   onClick={()=> handleSave()} />
             //:<></>
            }
            </div>      
      </Grid>
      <Grid className="filtersReport">
      {
       selSelect === false && selView=== true?   
        <TreeView
         columnas={state?.reportPreviewData?.columnas}                  
         camposPivotes={state?.reportPreviewData?.columnas}          
         />         
       :selSelect === true && selView=== false?
       namecoulumsID.length >0 ?
       namecoulumsID.map((column:any)=>{
            return (
                <FilesTable key={column.id} 
                       type                   = {'text'}
                       name                   = {column.value}
                       label                  = {column.value}
                       width                  = {'250px'}                                                                   
                       reload={state?.reportPreviewData?.reload}
                       setReload={state?.reportPreviewData?.setReload}     
                       setAddTxt={setAddTxt}      
                       onChange={handleChangeFile}     
                       value={currentRowValues[column.value] || ''}                                         
                />
                
              )      
          })            
         :<><p className="containerComponentReport">Este informe no tiene filtros</p></>        
         :<></>        
        }
      </Grid>  
    </Box> 
  )
}

export default FilterContainer